var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoldericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 86,
    viewBox: "0 0 84 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.50002 85.579H81.281C82.1091 85.579 82.781 84.9071 82.781 84.079V48.188C82.781 47.3599 82.1091 46.688 81.281 46.688H76.7029L76.699 9.50001C76.699 9.4297 76.6873 9.3711 76.66 9.3086C76.6287 9.25001 76.6014 9.18751 76.5506 9.14844L68.5506 1.14844C68.4998 1.09766 68.449 1.07032 68.3904 1.03906C68.3318 1.00781 68.2615 1 68.199 1H7.58201C7.30076 1 7.08201 1.21875 7.08201 1.5V34.121H2.50391C1.67579 34.121 1.00391 34.7929 1.00391 35.621L1 47.187V84.078C1 84.91 1.67188 85.578 2.5 85.578L2.50002 85.579ZM68.699 2.71201L74.9881 9.00111H68.699V2.71201ZM8.08202 2.00107H67.703V9.50107C67.703 9.78232 67.9218 10.0011 68.203 10.0011H75.703L75.6991 46.6891H40.6721L31.7112 34.3301C31.6214 34.2012 31.4612 34.1191 31.3011 34.1191H8.08206L8.08202 2.00107ZM2.00002 47.1891V35.6191C2.00002 35.3378 2.21877 35.1191 2.50002 35.1191H31.039L39.4179 46.6891H10.6599C10.3787 46.6891 10.1599 46.9078 10.1599 47.1891C10.1599 47.4703 10.3787 47.6891 10.6599 47.6891H81.2809C81.5622 47.6891 81.7809 47.9078 81.7809 48.1891V84.0801C81.7809 84.3613 81.5622 84.5801 81.2809 84.5801H2.49992C2.21867 84.5801 1.99992 84.3613 1.99992 84.0801L2.00002 47.1891Z",
    fill: "#32B3D2",
    stroke: "white",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8911 13.79H41.8911C42.1724 13.79 42.3911 13.5713 42.3911 13.29C42.3911 13.0088 42.1724 12.79 41.8911 12.79H11.8911C11.6099 12.79 11.3911 13.0088 11.3911 13.29C11.3911 13.5713 11.6099 13.79 11.8911 13.79Z",
    fill: "#32B3D2",
    stroke: "white",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8911 16.29H41.8911C42.1724 16.29 42.3911 16.0713 42.3911 15.79C42.3911 15.5088 42.1724 15.29 41.8911 15.29H11.8911C11.6099 15.29 11.3911 15.5088 11.3911 15.79C11.3911 16.0713 11.6099 16.29 11.8911 16.29Z",
    fill: "#32B3D2",
    stroke: "white",
    strokeWidth: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8911 18.79H71.8911C72.1724 18.79 72.3911 18.5713 72.3911 18.29C72.3911 18.0088 72.1724 17.79 71.8911 17.79H11.8911C11.6099 17.79 11.3911 18.0088 11.3911 18.29C11.3911 18.5713 11.6099 18.79 11.8911 18.79Z",
    fill: "#32B3D2",
    stroke: "white",
    strokeWidth: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8911 21.29H71.8911C72.1724 21.29 72.3911 21.0713 72.3911 20.79C72.3911 20.5088 72.1724 20.29 71.8911 20.29H11.8911C11.6099 20.29 11.3911 20.5088 11.3911 20.79C11.3911 21.0713 11.6099 21.29 11.8911 21.29Z",
    fill: "#32B3D2",
    stroke: "white",
    strokeWidth: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8911 23.79H71.8911C72.1724 23.79 72.3911 23.5713 72.3911 23.29C72.3911 23.0088 72.1724 22.79 71.8911 22.79H11.8911C11.6099 22.79 11.3911 23.0088 11.3911 23.29C11.3911 23.5713 11.6099 23.79 11.8911 23.79Z",
    fill: "#32B3D2",
    stroke: "white",
    strokeWidth: 0.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8911 26.29H71.8911C72.1724 26.29 72.3911 26.0713 72.3911 25.79C72.3911 25.5088 72.1724 25.29 71.8911 25.29H11.8911C11.6099 25.29 11.3911 25.5088 11.3911 25.79C11.3911 26.0713 11.6099 26.29 11.8911 26.29Z",
    fill: "#32B3D2",
    stroke: "white",
    strokeWidth: 0.8
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8911 28.79H71.8911C72.1724 28.79 72.3911 28.5713 72.3911 28.29C72.3911 28.0088 72.1724 27.79 71.8911 27.79H11.8911C11.6099 27.79 11.3911 28.0088 11.3911 28.29C11.3911 28.5713 11.6099 28.79 11.8911 28.79Z",
    fill: "#32B3D2",
    stroke: "white",
    strokeWidth: 0.8
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3911 30.79C72.3911 30.5088 72.1724 30.29 71.8911 30.29H11.8911C11.6099 30.29 11.3911 30.5088 11.3911 30.79C11.3911 31.0713 11.6099 31.29 11.8911 31.29H71.8911C72.1724 31.29 72.3911 31.0713 72.3911 30.79Z",
    fill: "#32B3D2",
    stroke: "white",
    strokeWidth: 0.8
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8911 32.79H34.3911C34.1099 32.79 33.8911 33.0088 33.8911 33.29C33.8911 33.5713 34.1099 33.79 34.3911 33.79H71.8911C72.1724 33.79 72.3911 33.5713 72.3911 33.29C72.3911 33.0088 72.1724 32.79 71.8911 32.79Z",
    fill: "#32B3D2",
    stroke: "white",
    strokeWidth: 0.8
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8911 35.29H37.1211C36.8398 35.29 36.6211 35.5088 36.6211 35.79C36.6211 36.0713 36.8398 36.29 37.1211 36.29H71.8911C72.1723 36.29 72.3911 36.0713 72.3911 35.79C72.3911 35.5088 72.1723 35.29 71.8911 35.29Z",
    fill: "#32B3D2",
    stroke: "white",
    strokeWidth: 0.8
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8912 37.79H38.7002C38.4189 37.79 38.2002 38.0088 38.2002 38.29C38.2002 38.5713 38.4189 38.79 38.7002 38.79H71.8912C72.1724 38.79 72.3912 38.5713 72.3912 38.29C72.3912 38.0088 72.1724 37.79 71.8912 37.79Z",
    fill: "#32B3D2",
    stroke: "white",
    strokeWidth: 0.8
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8912 40.29H40.2822C40.001 40.29 39.7822 40.5088 39.7822 40.79C39.7822 41.0713 40.001 41.29 40.2822 41.29H71.8912C72.1725 41.29 72.3912 41.0713 72.3912 40.79C72.3912 40.5088 72.1725 40.29 71.8912 40.29Z",
    fill: "#32B3D2",
    stroke: "white",
    strokeWidth: 0.8
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8911 42.79H41.8711C41.5898 42.79 41.3711 43.0088 41.3711 43.29C41.3711 43.5713 41.5898 43.79 41.8711 43.79H71.8911C72.1723 43.79 72.3911 43.5713 72.3911 43.29C72.3911 43.0088 72.1723 42.79 71.8911 42.79Z",
    fill: "#32B3D2",
    stroke: "white",
    strokeWidth: 0.8
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3911 73.79H76.8911C77.1724 73.79 77.3911 73.5713 77.3911 73.29C77.3911 73.0088 77.1724 72.79 76.8911 72.79H59.3911C59.1099 72.79 58.8911 73.0088 58.8911 73.29C58.8911 73.5713 59.1099 73.79 59.3911 73.79Z",
    fill: "#32B3D2",
    stroke: "white",
    strokeWidth: 0.8
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3911 76.29H76.8911C77.1724 76.29 77.3911 76.0713 77.3911 75.79C77.3911 75.5088 77.1724 75.29 76.8911 75.29H59.3911C59.1099 75.29 58.8911 75.5088 58.8911 75.79C58.8911 76.0713 59.1099 76.29 59.3911 76.29Z",
    fill: "#32B3D2",
    stroke: "white",
    strokeWidth: 0.8
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3911 78.79H76.8911C77.1724 78.79 77.3911 78.5713 77.3911 78.29C77.3911 78.0088 77.1724 77.79 76.8911 77.79H59.3911C59.1099 77.79 58.8911 78.0088 58.8911 78.29C58.8911 78.5713 59.1099 78.79 59.3911 78.79Z",
    fill: "#32B3D2",
    stroke: "white",
    strokeWidth: 0.8
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3911 81.29H76.8911C77.1724 81.29 77.3911 81.0713 77.3911 80.79C77.3911 80.5088 77.1724 80.29 76.8911 80.29H59.3911C59.1099 80.29 58.8911 80.5088 58.8911 80.79C58.8911 81.0713 59.1099 81.29 59.3911 81.29Z",
    fill: "#32B3D2",
    stroke: "white",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoldericon);
export default __webpack_public_path__ + "static/media/foldericon.13158e1e4246613229decbe30a5a8796.svg";
export { ForwardRef as ReactComponent };